import React from 'react';
import { Trans } from 'react-i18next';
import Link from '../links/Link';
import style from './DefaultDisclaimer.module.scss';

export const DefaultDisclaimer: React.FC = () => {
  return (
    <p className={style.disclaimer} data-testid="default-disclaimer">
      <Trans>
        Atto is made by The IDCo. Ltd., a registered Account Information Service Provider by the Financial Conduct
        Authority, AISP registration number{' '}
        <Link href={'https://register.fca.org.uk/s/firm?id=0010X000046GUvIQAW'} target="_blank">
          798579
        </Link>
        . For further details please see our{' '}
        <Link href={'https://www.atto.co/policies'} target="_blank">
          Privacy Policy
        </Link>
        .
      </Trans>
    </p>
  );
};

export default DefaultDisclaimer;
